import PaymentConfirmation from "./PaymentConfirmation";

export default PaymentConfirmation;
